import { render, staticRenderFns } from "./AIChatWidgetAbHero.vue?vue&type=template&id=6b3de5be&scoped=true"
import script from "./AIChatWidgetAbHero.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetAbHero.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetAbHero.vue?vue&type=style&index=0&id=6b3de5be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3de5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3de5be')) {
      api.createRecord('6b3de5be', component.options)
    } else {
      api.reload('6b3de5be', component.options)
    }
    module.hot.accept("./AIChatWidgetAbHero.vue?vue&type=template&id=6b3de5be&scoped=true", function () {
      api.rerender('6b3de5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetAbHero.vue"
export default component.exports